import { Link } from 'react-router-dom';

const friendLinks = ['星辰影视论坛', '光影资料库', '追剧日历', '字幕爱好社区', '电影配乐电台'];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">在线免费观看</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              致力于为广大影视爱好者提供海量且免费的在线视频资源，涵盖电影、电视剧、综艺节目等多种内容，支持分类浏览、筛选与在线演示播放。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              <a href="#footer-nav" className="cursor-pointer">快捷导航</a>
            </h4>
            <ul id="footer-nav" className="space-y-2 text-sm">
              <li><Link to="/" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/movie" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">电影频道</Link></li>
              <li><Link to="/category/tv" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">电视剧频道</Link></li>
              <li><Link to="/category/variety" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">综艺频道</Link></li>
              <li><Link to="/about" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              <a href="#footer-contact" className="cursor-pointer">联系我们</a>
            </h4>
            <ul id="footer-contact" className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-500"></i>support@zaixianmianfei.example</li>
              <li className="flex items-center gap-2"><i className="ri-phone-line text-primary-500"></i>400-000-0000（工作日 9:00-18:00）</li>
              <li className="flex items-center gap-2"><i className="ri-map-pin-line text-primary-500"></i>北京市朝阳区影视文化产业园</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-xs text-foreground-500">
            <span className="text-foreground-700 font-medium">友情链接：</span>
            {friendLinks.map((link) => (
              <a key={link} href="#friend-links" className="hover:text-primary-700 transition-colors cursor-pointer">
                {link}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-5 border-t border-background-200">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-foreground-500">
          <span>© 2024 在线免费观看 · 本站所有内容均为演示数据，仅供产品展示，不提供真实视频播放服务。</span>
          <span className="whitespace-nowrap">仅供学习交流 · 请勿用于商业用途</span>
        </div>
      </div>
    </footer>
  );
}